import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Icon } from '@ovComponents/1-primative/icon/icon';
import type { Theme } from 'hephaestus/core';
import { Box, Tooltip, Typography } from 'hephaestus/web';
import type { TFunction } from 'i18next';
import { Trans } from 'react-i18next';
export type AgingColumnHeaderProps = {
  t: TFunction;
  theme: Theme;
};

export const AgingColumnHeader = ({ t, theme }: AgingColumnHeaderProps) => (
  <Box
    component='span'
    sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}
  >
    <Typography
      component='span'
      variant='bodySmall'
      sx={{
        fontWeight: 600,
        textTransform: 'none',
        letterSpacing: '0.02em',
        color: theme.color.onSurfaceVariant,
      }}
    >
      {t('reconFlags.filters.aging')}
    </Typography>
    <Tooltip
      resizing='fixedLarge'
      title={
        <Box component='span' sx={{ display: 'block', textAlign: 'left' }}>
          <Trans
            ns='reconciliation'
            i18nKey='reconFlags.agingHelp'
            components={{ bold: <strong /> }}
          />
        </Box>
      }
    >
      <Box
        component='span'
        role='button'
        tabIndex={0}
        aria-label={String(t('reconFlags.agingHelpAria'))}
        sx={{
          display: 'flex',
          alignItems: 'center',
          color: String(theme.color.onSurfaceVariant),
          cursor: 'pointer',
          flexShrink: 0,
        }}
      >
        <Icon icon={InfoOutlinedIcon} size='small' />
      </Box>
    </Tooltip>
  </Box>
);
